
import { Button } from "antd";
import { SortAscendingOutlined } from "@ant-design/icons";

import { React, useState, useEffect, useContext } from "react";
import axios from "axios";
import { VideoContext } from "../Helper/Context";

import "./GenralPanel.css";
import config from '../config.json'

// Todo
// Create a get call to get all videos
// Create a UseState to store the filteredvideos and update its state on the basis of button clicked


function Genre() {
  const myVideos = useContext(VideoContext);

  function updateArray(value) {
    // if clicked button is already in array remove that.
    if (show.includes(value) === true) {
      document.getElementById(value).classList.remove("active");
      const arr = show.filter((item) => item !== value);
      setShow(arr);
    } else {
      document.getElementById(value).classList.add("active");
      const arr = [...show, value]; //else just extend the array
      setShow(arr);
    }
  }

  async function apiCall(searchQuery) {
    let url = `${config.endpoint}/videos?`;
    url = url + searchQuery;
    const res = await axios
      .get(url)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (err.response) {
          return null;
        }
        return err;
      });

    if (res !== null) {
     
      
      return res.data.videos;
    } else {
      return null;
    }
  }

  async function sortBy(value) {
    let searchQuery = "sortBy=" + value;
    console.log(searchQuery);

    const res = await apiCall(searchQuery);
    if (res != null) {
      myVideos.setVideo(res);
    }
  }

  const [show, setShow] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    if (show.length === 0) {
      document.getElementById("All").classList.add("active");
      document.querySelectorAll(".toggle").forEach((el) => {
        el.classList.remove("active");
      });
      myVideos.setChange(true);
    } else if (show.length > 0) {
      document.getElementById("All").classList.remove("active");
      let searchQuery = "genres=";
      for (let x of show) {
        searchQuery = searchQuery + x + ",";
      }

      const res = await apiCall(searchQuery);
      if (res != null) {
        myVideos.setVideo(res);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <div className="genre">
      <Button className="genre-btn active" id="All" onClick={() => setShow([])}>
        All Genre
      </Button>
      <Button
        className="genre-btn toggle "
        id="Education"
        onClick={() => updateArray("Education")}
      >
        Education
      </Button>
      <Button
        type="dashed"
        className="genre-btn toggle"
        id="Sports"
        onClick={() => updateArray("Sports")}
      >
        Sports
      </Button>
      <Button
        type="dashed"
        className="genre-btn toggle"
        id="Comedy"
        onClick={() => updateArray("Comedy")}
      >
        Comedy
      </Button>
      <Button
        type="dashed"
        className="genre-btn toggle"
        id="LifeStyle"
        onClick={() => updateArray("LifeStyle")}
      >
        LifeStyle
      </Button>
      <Button type="dashed toggle" className="sor-select active">
        <label for="sort">
          <SortAscendingOutlined />
          SortBy:
        </label>
        <select
          id="sort"
          className="sort-select"
          name="sortBy"
          onChange={(e) => sortBy(e.target.value)}
        >
          <option id="release-date-option" value="releaseDate">
            Release Date
          </option>
          <option id="view-count-option" value="viewCount">
            View Count
          </option>
        </select>
      </Button>
    </div>
  );
}

function Rating() {
  const myVideos = useContext(VideoContext);
  const [show, setShow] = useState("");

  async function apiCall(searchQuery) {
    let url = `${config.endpoint}/videos?`;
    url = url + searchQuery;

    const res = await axios
      .get(url)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        if (err.response) {
          return null;
        }
      });
  

    if (res !== null) {
   
      return res.data.videos;
    } else {
      return null;
    }
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
   
    let searchQuery = "contentRating=";
    searchQuery = searchQuery + show + "%2B";
    console.log(searchQuery);

    const res = await apiCall(searchQuery);
    if (res) {
      myVideos.setVideo(res);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <div className="content">
      <Button
        type="text"
        className="content-rating-btn active"
        id="Any"
        onClick={(e) => myVideos.setChange(true)}
      >
        Any Age Group
      </Button>
      <Button
        type="text"
        className="content-rating-btn"
        id="7"
        onClick={(e) => setShow("7")}
      >
        7+
      </Button>
      <Button
        type="text"
        className="content-rating-btn"
        id="12"
        onClick={(e) => setShow("12")}
      >
        12+
      </Button>
      <Button
        type="text"
        className="content-rating-btn"
        id="16"
        onClick={(e) => setShow("16")}
      >
        16+
      </Button>
      <Button
        type="text"
        className="content-rating-btn"
        id="18"
        onClick={(e) => setShow("18")}
      >
        18+
      </Button>
    </div>
  );
}

function GeneralPanel() {
  return (
    <div className="panel">
      <Genre />
      <Rating />
    </div>
  );
}

export { GeneralPanel };
